module.exports = __webpack_public_path__ + "static/img/bg48.777516a3.png";